import { Box, IconButton, Title } from '@nimbus-ds/components';
import { CloseIcon } from '@nimbus-ds/icons';
import logo from './img/logoComp.png';
import speakers from './img/speakers.png';
import './D2CBannerMobile.scss';

interface D2CBannerMobileProps {
  onClick: () => void;
  onClose: () => void;
}

function D2CBanner({ onClick, onClose }: D2CBannerMobileProps) {
  return (
    <div className="stratus--banner-mobile">
      <div className="banner__close">
        <IconButton
          onClick={onClose}
          backgroundColor="transparent"
          source={<CloseIcon size="small" />}
        />
      </div>
      <Box display="flex" flexDirection="column" gap="none">
        <Box
          as="section"
          display="flex"
          justifyContent="space-between"
          paddingLeft="6"
          gap="11"
        >
          <Box display="flex" flexDirection="column" paddingTop="6">
            <Box display="flex" alignItems="center">
              <img src={logo} className="banner__logo" />
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              flexWrap="wrap"
              gap="4"
              marginTop="4"
            >
              <Box display="flex" flexDirection="column" gap="7">
                <Box display="flex" flexDirection="column" gap="none">
                  <Title as="h6" fontSize="3" color="neutral-background">
                    Impulsionando as vendas online no Brasil
                  </Title>
                  <Title
                    as="h6"
                    fontWeight="regular"
                    fontSize="3"
                    color="neutral-background"
                  >
                    30/Set e 01/Out — Distrito Anhembi, SP
                  </Title>
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                  gap="1"
                  paddingBottom="6"
                >
                  <Title as="h6" fontSize="3" color="neutral-background">
                    Primeiro lote aberto:
                  </Title>
                  <button className="banner__button" onClick={onClick}>
                    Garanta seu ingresso com 20% off
                  </button>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="2"
          >
            <img src={speakers} />
          </Box>
        </Box>
        <div className="banner__footer">
          <Box
            as="footer"
            display="flex"
            justifyContent="space-evenly"
            gap={{ xs: '2', md: '6' }}
            paddingTop="1-5"
            paddingBottom="1-5"
            paddingLeft="4-5"
            paddingRight="4-5"
          >
            <Title as="h6" fontSize="3" color="neutral-background">
              +100 atrações
            </Title>
            <Title as="h6" fontSize="3" color="neutral-background">
              +5 mil participantes
            </Title>
            <Title as="h6" fontSize="3" color="neutral-background">
              2 dias de evento
            </Title>
          </Box>
        </div>
      </Box>
    </div>
  );
}

export default D2CBanner;
